import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Box, Button, Divider } from '@mui/material';
import { Delete, Visibility } from '@mui/icons-material';

import { Employer } from '@libs/models';
import { useEmployerAdminSearchQuery } from '@carcareers/store';
import { useEmployer } from '@carcareers/hooks';
import { FormProvider, useDrawer } from '@carcareers/contexts';
import { DashboardPageContainer, Drawer, EmployerCreateForm, DataGridV2 as DataGrid } from '@carcareers/components';
import {
  EMPLOYER_INDEX_COLUMNS,
  EMPLOYER_INDEX_COLUMN_INITIAL_STATE,
  routes,
  useIsMobile,
  EMPLOYER_INDEX_COLUMNS_INITIAL_STATE_MOBILE,
} from '@carcareers/utils';

export const EmployerIndex: FC = () => {
  const navigate = useNavigate();
  const { setOpen } = useDrawer();
  const { deleteEmployer } = useEmployer();
  const search = useEmployerAdminSearchQuery;
  const isMobile = useIsMobile();

  const columns = [
    ...EMPLOYER_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() =>
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_EMPLOYERS_VIEW.replace(':id', params.row.id.toString())}`)
          }
        />,
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => deleteEmployer(params.row.id)}
        />,
      ],
    },
  ];

  return (
    <>
      <DashboardPageContainer>
        <DataGrid<Employer>
          query={search}
          columns={columns}
          tools={
            <>
              <Button onClick={() => setOpen(true)} variant="contained" color="primary">
                Add
              </Button>
              <Divider orientation="vertical" sx={{ height: 24, ml: 1 }} />
            </>
          }
          initialState={{
            columns: {
              columnVisibilityModel: isMobile
                ? EMPLOYER_INDEX_COLUMNS_INITIAL_STATE_MOBILE
                : EMPLOYER_INDEX_COLUMN_INITIAL_STATE,
            },
          }}
        />
      </DashboardPageContainer>
      <Drawer title="Add Employer" width={500}>
        <FormProvider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', p: 2 }}>
            <EmployerCreateForm />
          </Box>
        </FormProvider>
      </Drawer>
    </>
  );
};

export default EmployerIndex;
